import React, { useState, useEffect } from "react";
import { selectDateOrTime } from "../../../../../../services/saleAnalysis-services";
import {
    Button,
    Container,
    Dialog,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { uri } from "../../../../../../help/Api";
import TotalCard from "../../../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import { sto } from "../../../../../../Context/InshData";
import ReplyIcon from "@material-ui/icons/Reply";
import SearchReceiptForm from "./SearchReceiptForm";
import SearchReceiptTable from "./SearchReceiptTable";
import deepRenameKeys from "deep-rename-keys";
import { GetItemFromOptions } from "../../../../../../services/global-services";
import SearchSandFilter from "./SearchSandFilter";
import { GetEmpFromOptions } from "../../external-exchange-voucher/EExchangeVoucher";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: "#d3d3d3",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#d3d3d3",
        borderColor: "#808080",
    },
}));

export default function SearchReceipt(props) {
    const { openSearchMdl, handCloseDw,
        onRowClick, URL, type, tname, AutoOptions, transition, isInternal,
        AutoOptionsB
    } = props;

    const [branches, setBranches] = useState(() => {
        return [{ id: -1, name: "الكل" }, ...AutoOptionsB?.Branches];
    });
    const valuebranch = GetItemFromOptions(sto.branchi, AutoOptionsB.Branches ?? []);
    const valueUser = GetEmpFromOptions(sto.empi, AutoOptions.Users ?? []);
    const typePays = [
        { id: -1, name: "الكل", label: "الكل" },
        { id: 1, name: "كاش", label: "كاش" },
        { id: 2, name: "شبكة", label: "شبكة" },
        { id: 3, name: "بنك", label: "بنك" },

    ];

    const initialSearchObject = {
        dateFrom: moment(new Date().setDate(new Date().getDate() - 1)).format("YYYY-MM-DD"),
        timeFrom: moment(new Date()).startOf("day").format("HH:mm"),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        timeTo: moment(new Date()).format('HH:mm'),
        user: { id: sto.User_typei == 1 ? -1 : valueUser?.id, name: sto.User_typei == 1 ? 'الكل' : valueUser?.name },
        branch: sto.User_typei == 1 ? branches[0] : valuebranch,
        selectTime: selectDateOrTime[0],
        sales_man: { id: -1, name: "الكل" },
        cust: { id: -1, name: "الكل", code: -1 },
        acc_code: { id: -1, name: "الكل", code: -1 },
        date_time: "false",
        refno: "",
        id: "",
        notes: "",
        tname: tname,
        isAdmin: sto.User_typei == 1,
        value: '',
        valFrom: '',
        valto: '',
        pay_type: typePays[0],
        center: { id: -1, name: "الكل" },
        tranNo: "",
    };

    const [rptParams, setRptParams] = React.useState(initialSearchObject);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const { t } = useTranslation(["forms", "translation"]);

    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const viewHandle = async () => {
        setData([]);
        setFetching(true);
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `AccountReports/SandsSearch?branch=${rptParams?.branch.id}&&id=${rptParams?.id}&&tname=${rptParams?.tname}
        &&fDate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}&&tDate=${rptParams.dateTo + ' ' + rptParams.timeTo}&&sale_emp=${rptParams?.user.id}
        &&cust_id=${isInternal ? rptParams?.cust?.code : rptParams?.cust?.id}&&refno=${rptParams?.refno}&&notes=${rptParams?.notes}
        &&center=${rptParams.center?.id}&&type=${rptParams.pay_type?.id} &&value=${rptParams?.value}&&valfrom=${rptParams?.valFrom}
        &&valto=${rptParams?.valto}&&date_time=${rptParams.selectTime.name}&&tranNo=${rptParams?.tranNo}`
        } else {
            Urls = `AccountReports/SandsSearch?branch=${rptParams?.branch.id}&&id=${rptParams?.id}&&tname=${rptParams?.tname}
        &&fDate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}&&tDate=${rptParams.dateTo + ' ' + rptParams.timeTo}&&sale_emp=${rptParams?.user.id}
        &&cust_id=${isInternal ? rptParams?.cust?.code : rptParams?.cust?.id}&&refno=${rptParams?.refno}&&notes=${rptParams?.notes}
        &&center=${rptParams.center?.id}&&type=${rptParams.pay_type?.id} &&value=${rptParams?.value}&&valfrom=${rptParams?.valFrom}
        &&valto=${rptParams?.valto}&&date_time=${rptParams.selectTime.name}&&tranNo=${rptParams?.tranNo}&&db_name=${sto?.db_name}`
        }
        await axios
            .get(
                uri +Urls
            )
            .then((res) => {
                const sanad_Data = res.data?.sanadData.map((row, i) => {
                    return {
                        ...row,
                        sanadType: row.type == 1 ? "كاش" : row.type == 2 ? "شبكة" : "بنك",
                    };
                });

                setData({ sanadData: sanad_Data ?? [] });
                // setData(res.data);
                console.log(" the data is", res.data);
                setFetching(false);
            })
            .catch((err) => {
                viewHandleOld();
            });
    };

    const viewHandleOld = async () => {

        setData([]);
        setFetching(true);
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls =  `AccountReports/SandsSearch?branch=${rptParams?.branch.id}&&id=${rptParams?.id}
            &&tname=${rptParams?.tname}&&fDate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
            &&tDate=${rptParams.dateTo + ' ' + rptParams.timeTo}&&sale_emp=${rptParams?.user.id}&&cust_id=${isInternal ? rptParams?.cust?.code : rptParams?.cust?.id}
            &&refno=${rptParams?.refno}&&notes=${rptParams?.notes}&&center=${rptParams.center?.id}&&type=${rptParams.pay_type?.id} 
            &&value=${rptParams?.value}&&valfrom=${rptParams?.valFrom}&&valto=${rptParams?.valto}`
        } else {
            Urls =   `AccountReports/SandsSearch?branch=${rptParams?.branch.id}&&id=${rptParams?.id}
            &&tname=${rptParams?.tname}&&fDate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
            &&tDate=${rptParams.dateTo + ' ' + rptParams.timeTo}&&sale_emp=${rptParams?.user.id}&&cust_id=${isInternal ? rptParams?.cust?.code : rptParams?.cust?.id}
            &&refno=${rptParams?.refno}&&notes=${rptParams?.notes}&&center=${rptParams.center?.id}&&type=${rptParams.pay_type?.id} 
            &&value=${rptParams?.value}&&valfrom=${rptParams?.valFrom}&&valto=${rptParams?.valto}&&db_name=${sto?.db_name}`
        }
        await axios
            .get(
                uri +Urls
            )
            .then((res) => {
                const sanad_Data = res.data?.sanadData.map((row, i) => {
                    return {
                        ...row,
                        sanadType: row.type == 1 ? "كاش" : row.type == 2 ? "شبكة" : "بنك",
                    };
                });

                setData({ sanadData: sanad_Data ?? [] });
                // setData(res.data);
                console.log(" the data is", res.data);
                setFetching(false);
            })
            .catch((err) => {
                setFetching(false);
                console.log(err);
                setData([]);
            });
    };
    const his = useHistory();


    let excel_name = "SandsReports";
    const excelHeaders = [
        { label: "الرقم", key: "id" },
        { label: "التاريخ", key: "date" },
        { label: t("account"), key: "acc_name" },
        { label: t("delegate"), key: "empName" },
        { label: "المبلغ", key: "val" },
        { label: "طريقة الدفع", key: "sanadType" },
        { label: t("ref-no"), key: "ref_no" },
        { label: t("note"), key: "notess" },
        // { label: "شبكة", key: "network_part" },
        // { label: "تحويل", key: "bank_part" },

    ];
    var columns = [
        { title: t("no"), field: "id", },
        { title: t("date"), field: "date", },
        {
            title: t("account"),
            field: "acc_name",

        },
        {
            title: t("amount"),
            field: "val",

        },
        {
            title: t("delegate"),
            field: "empName",

        },
        {
            title: t("ref-no"),
            field: "check_no",

        },
        {
            title: t("note"),
            field: "notes",
        },

    ];
    const excelHeaders2 = deepRenameKeys(columns, (key) => {
        if (key === "field") return "key";
        if (key === "title") return "label";
    });

    // useEffect(() => {
    //     console.log("the data is", rptParams);
    // });
    const changTField = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
    };
    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
    };
    const onChangeAutoDataCust = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue, acc_code: newValue });

    };

    return (
        <Dialog
            fullScreen
            open={openSearchMdl}
            onClose={handCloseDw}
            TransitionComponent={transition}
            key={transition ? transition.name : ""}
        >
            <div className={classes.root}>
                <Grid container item xs={12}>
                    <Typography
                        size="small"
                        className={classes.headerTitle}
                        color="primary"
                    >
                        {" البـحـث فـي السندات "}
                    </Typography>
                </Grid>
                <Typography
                    component="div"
                    style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
                >
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            padding: "10px",
                            paddingBottom: "0px",
                            borderBottomColor: "#808080",
                            borderBottomWidth: "1px",
                            borderBottomStyle: "solid",
                        }}
                    >
                        <SearchSandFilter {...{ rptParams, setRptParams }} />

                        <SearchReceiptForm
                            {...{

                                type, tname,
                                rptParams,
                                onChangeData,
                                onChangeAutoData,
                                typePays,
                                AutoOptions,
                                isInternal,
                                onChangeAutoDataCust,
                                branches,
                                AutoOptionsB,
                            }}
                        />
                        <Grid
                            container
                            justifyContent="center"
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            spacing={1}
                        >
                            <Hidden smUp={["sm"]}>
                                <Grid item>
                                    <Button
                                        disabled={fetching}
                                        variant="contained"
                                        startIcon={<ScannerIcon />}
                                        size="large"
                                        style={
                                            (inshst.sal.iconBtnAcc,
                                                { borderRadius: 0 })
                                        }
                                        className={[clasui.buttonAcc]}
                                        onClick={() => viewHandle()}
                                    >
                                        {t("forms:show")}
                                    </Button>
                                </Grid>
                            </Hidden>
                            <Hidden only={["xs"]}>
                                <Grid item>
                                    <Button
                                        disabled={fetching}
                                        variant="contained"
                                        startIcon={<ScannerIcon />}
                                        size="large"
                                        style={
                                            (inshst.sal.iconBtnAcc,
                                                { borderRadius: 0 })
                                        }
                                        className={[clasui.buttonAcc]}
                                        onClick={() => viewHandle()}
                                    >
                                        {t("forms:view")}
                                    </Button>
                                </Grid>
                            </Hidden>
                            <Hidden smUp={["sm"]}>

                                <Grid item >
                                    {data.sanadData && !fetching && (
                                        <CSVLink
                                            separator={";"}
                                            filename={excel_name}
                                            data={data.sanadData}
                                            headers={excelHeaders}
                                        >
                                            {" "}
                                            <Button
                                                disabled={fetching}
                                                variant="contained"
                                                startIcon={<TableChart />}
                                                size="large"
                                                color="primary"
                                                style={{ borderRadius: 0 }}
                                                className={[clasui.buttonAcc]}
                                            >
                                                {t("excel")}
                                            </Button>
                                        </CSVLink>
                                    )}
                                </Grid>
                            </Hidden>
                            <Hidden only={["xs"]}>
                                <Grid item >
                                    {data.sanadData && !fetching && (
                                        <CSVLink
                                            separator={";"}
                                            filename={excel_name}
                                            data={data.sanadData}
                                            headers={excelHeaders}
                                        >
                                            {" "}
                                            <Button
                                                disabled={fetching}
                                                variant="contained"
                                                startIcon={<TableChart />}
                                                size="large"
                                                color="primary"
                                                style={{ borderRadius: 0 }}
                                                className={[clasui.buttonAcc]}
                                            >
                                                {t("excel_export")}{" "}
                                            </Button>
                                        </CSVLink>
                                    )}
                                </Grid>
                            </Hidden>

                            <Grid item>
                                <Button
                                    variant="contained"
                                    // startIcon={<KeyboardReturnSharpIcon />}
                                    startIcon={<ReplyIcon />}
                                    color="secondary"
                                    size="large"
                                    aria-label="open drawer"
                                    className={[clasui.button, clasSp.clcan]}
                                    style={
                                        (inshst.sal.iconBtn,
                                            { borderRadius: 0 })
                                    }
                                    onClick={() => handCloseDw()}
                                >
                                    {/* {t("forms:exit")} */}
                                    {t("back")}
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>
                    <Container maxWidth={true} style={{ padding: "4px" }}>
                        <Grid container spacing={1} style={{ paddingTop: "10px" }}>

                            <Grid item lg={2} md={2} sm={4} xs={6}>
                                <TotalCard
                                    {...{
                                        className: classes.purchTotalCard,
                                        title: " عدد السجلات",
                                        value: data?.sanadData?.length,
                                    }}
                                />
                            </Grid>
                            <Grid item lg={2} md={2} sm={4} xs={6}>
                                <TotalCard
                                    {...{
                                        className: classes.purchTotalCard,
                                        title: "الإجمالي: ",
                                        value: (data?.sanadData?.reduce((a, v) => (a = a + v.val), 0).toFixed(2)),
                                    }}
                                />
                            </Grid>


                        </Grid>
                    </Container>
                    <br />
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            paddingRight: "5px",
                            paddingLeft: "5px",
                        }}
                    >
                        <Grid container justifyContent="center">
                            <Grid item container justifyContent="center" xs={12}>
                                <BeatLoader loading={fetching} color="#808080" />
                                {!fetching && (
                                    <SearchReceiptTable
                                        {...{
                                            //  data: data ? data : [],
                                            data: data?.sanadData ? data.sanadData : [],
                                            onRowClick, rptParams
                                        }}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Container>
                </Typography>
            </div>
        </Dialog>
    );
}
